import { render, staticRenderFns } from "./balance-list.vue?vue&type=template&id=1dd14ab2&"
import script from "./balance-list.vue?vue&type=script&lang=js&"
export * from "./balance-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports